<head>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN" crossorigin="anonymous">
</head>
<main class="mat-app-background" [ngClass]="themeClass">
        <app-connection-banner></app-connection-banner>
        <app-algo-trading-banner></app-algo-trading-banner>
        <app-header ></app-header>
        <router-outlet></router-outlet>
<!--         <div class="flex-grow-1"></div>
        <app-footer *ngIf="router.url !== '/models'"></app-footer> -->
</main>
